"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAM = exports.SEARCH_PARAM = void 0;
const PARAM = Object.freeze({
    rightsholderId: ':rightsholderId',
    workId: ':workId',
    typeWork: ':typeWork',
    userId: ':userId',
    activatingCode: ':activatingCode',
    recordingId: ':recordingId',
    contactId: ':contactId',
    submissionId: ':submissionId',
    recordingGroupCategory: ':recordingGroupCategory',
    overclaimHeaderId: ':overclaimHeaderId',
    tabName: ':tabName',
    songwriterId: ':songwriterId',
    cowriterIpId: ':cowriterIpId',
});
exports.PARAM = PARAM;
const SEARCH_PARAM = Object.freeze({
    payee: 'payee',
    period: 'period',
    matchHistoryFilter: 'matchHistoryFilter',
});
exports.SEARCH_PARAM = SEARCH_PARAM;
